import { render, staticRenderFns } from "./AddPoiModal.vue?vue&type=template&id=1bc5bb9a&scoped=true&"
import script from "./AddPoiModal.vue?vue&type=script&lang=js&"
export * from "./AddPoiModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPoiModal.vue?vue&type=style&index=0&id=1bc5bb9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc5bb9a",
  null
  
)

export default component.exports